module.exports = __webpack_public_path__ + "media/images/icon_search_btn_old_on-679ac7f4fbfb55b322d33885d134a93c.png";